import React from 'react';

const GuestLayout: React.FC = ({ children }) => <div className="wrapper">{children}</div>;

export default GuestLayout;
